import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { autoLogin } from './lib/auth/insecureAuth';
import { supabase } from './lib/supabase';

// Attempt auto-login
if (typeof window !== 'undefined') {
  autoLogin(supabase).catch(console.error);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);